export const EXTERNAL_REDIRECT_MESSAGE = 'आपण ग्रामपंचायत पोर्टल सोडून बाह्य वेबसाइटवर जाणार आहात. पुढे जायचे का?';

export const openExternalWithNotice = (event, url) => {
  if (!url) return;
  event?.preventDefault?.();
  event?.stopPropagation?.();

  if (typeof window === 'undefined') return;
  if (!window.confirm(EXTERNAL_REDIRECT_MESSAGE)) return;

  window.open(url, '_blank', 'noopener,noreferrer');
};
